import React from "react";
import DataGridComponent from "Utils/Constants/DataGridComponent";
import { socialList } from "Utils/Helpers/TableColumns";

export default function TableSocialData({ data }) {
  return <DataGridComponent data={data} columns={socialList} />;
}

